(() => {
  const initExplorer = (root) => {
    if (root.dataset.harioReady === 'true') return;

    const materialFilter = root.querySelector('[data-hario-filter="material"]');
    const sizeFilter = root.querySelector('[data-hario-filter="size"]');
    const resetButton = root.querySelector('[data-hario-filter-reset]');
    const resultCount = root.querySelector('[data-hario-result-count]');
    const emptyMessage = root.querySelector('[data-hario-empty]');
    const cards = [...root.querySelectorAll('[data-hario-card]')];

    if (!materialFilter || !sizeFilter || !resetButton || !resultCount || !emptyMessage) return;

    const countTemplate = root.dataset.harioCountTemplate || '顯示 {visible} 款，共 {total} 款';

    const applyFilters = () => {
      const selectedMaterial = materialFilter.value;
      const selectedSize = sizeFilter.value;
      let visibleCount = 0;

      cards.forEach((card) => {
        const materialMatches = selectedMaterial === 'all' || card.dataset.material === selectedMaterial;
        const sizeMatches = selectedSize === 'all' || card.dataset.size === selectedSize;
        const isVisible = materialMatches && sizeMatches;

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      resultCount.textContent = countTemplate.replace('{visible}', String(visibleCount)).replace('{total}', String(cards.length));
      emptyMessage.hidden = visibleCount !== 0;
    };

    materialFilter.addEventListener('change', applyFilters);
    sizeFilter.addEventListener('change', applyFilters);
    resetButton.addEventListener('click', () => {
      materialFilter.value = 'all';
      sizeFilter.value = 'all';
      applyFilters();
      materialFilter.focus();
    });

    root.dataset.harioReady = 'true';
    applyFilters();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-hario-v60-explorer]').forEach(initExplorer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
